<template>
  <div class="form-group">
    <label for="text">
      Bill To
      <span class="star">*</span>
    </label>
    <el-select
      v-model="data.billing_type"
      v-if="billing_types"
      filterable
      default-first-option
    >
      <el-option
        v-for="(type, index) in billing_types"
        :key="index"
        :label="type.label"
        :value="type.value"
      ></el-option>
    </el-select>
    <p class="err" v-if="validataionErrors && validataionErrors[errorKey]">
      {{ validataionErrors[errorKey] }}
    </p>
  </div>
</template>

<script>
export default {
  props: ["billData", "validataionErrors", "errorKey"],
  data() {
    return {
      billing_types: this.getBillingTypes(),
      data: "",
    };
  },
  async mounted() {
    this.data = this.billData;
  },
  methods: {
    getBillingTypes() {
      return [
        {
          label: "INSURANCE",
          value: "INSURANCE",
        },
        {
          label: "PATIENT",
          value: "PATIENT",
        },
        {
          label: "CLIENT",
          value: "CLIENT",
        },
        {
          label: "LABCORP",
          value: "LABCORP",
        },
        // {
        //   label: "SENDOUT",
        //   value: "SENDOUT",
        // },
        // {
        //   label: "UNINSURED",
        //   value: "UNINSURED",
        // },
        // {
        //   label: "FINANCIAL ASSISTANCE",
        //   value: "FINANCIAL_ASSISTANCE",
        // },
        // {
        //   label: "HHS/HHA",
        //   value: "HHS_OR_HHA",
        // },
      ];
    },
  },
};
</script>

<style scoped>
.err {
  margin-top: 2px !important;
  color: #eb5757;
  font-size: 12px;
  min-height: 20px;
  white-space: nowrap;
  margin-bottom: -30px;
  line-height: 20px;
  font-weight: 500;
  padding-left: 2px;
}
</style>
